module.exports = __webpack_public_path__ + "static/media/Photo11.51c7f8e9.jpg";